import { Box } from '@wix/design-system';
import React from 'react';
import { useIsMobile, useValidChildren } from '../../hooks';
import ProductCard from './ProductCard/ProductCard';
import { ProductCardWrapper } from './ProductCard/ProductCardWrapper';
const modifyCardsUi = (validCards, gap) => {
    return validCards.reduce((modified, card, idx, allCards) => {
        const currCard = card;
        if (currCard.props.shadow && !gap) {
            if (idx > 0) {
                const prevCard = React.cloneElement(allCards[idx - 1], {
                    borderRight: 'none',
                    key: idx - 1,
                });
                modified[idx - 1] = prevCard;
            }
            if (idx < allCards.length - 1) {
                const nextCard = React.cloneElement(allCards[idx + 1], {
                    borderLeft: 'none',
                    key: idx + 1,
                });
                modified[idx + 1] = nextCard;
            }
        }
        return modified;
    }, validCards);
};
const ProductCardList = ({ children, gap }) => {
    const isMobile = useIsMobile();
    const validCards = useValidChildren(children, [ProductCard, ProductCardWrapper], () => `ProductCardList only accepts ProductCardList.Card (or ProductCardWrapper) as children. Got invalid child:`);
    const modifiedCards = modifyCardsUi(validCards, gap);
    return (React.createElement(Box, { direction: isMobile ? 'vertical' : 'horizontal', gap: gap && `${gap}px`, align: "center" }, modifiedCards));
};
ProductCardList.Card = ProductCard;
ProductCardList.Wrapper = ProductCardWrapper;
export default ProductCardList;
//# sourceMappingURL=ProductCardList.js.map